module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-31.5efd9c85.png";